/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import IconButton from '@material-ui/core/IconButton';
// import Tooltip from '@material-ui/core/Tooltip';

import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { Tooltip } from '../../Components/Tooltip';

export const columns = (handleOnClick, strings) => {
  const uid = 'id';

  // eslint-disable-next-line
  const ActionsColumnCellRenderer = ({ dataKey, parent, rowData, cellData, rowIndex }) => {
    // eslint-disable-next-line no-underscore-dangle
    window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;

    const getIcon = action => {
      switch (action.get('action')) {
        case 'modify':
          return <EditIcon fontSize="small" />;
        case 'cancel':
          return <DeleteIcon fontSize="small" />;
        case 'view':
          return <RemoveRedEyeIcon fontSize="small" />;
        case 'link':
          return <OpenInNewIcon fontSize="small" />;

        default:
          return strings[action.get('label')];
      }
    };
    const getColor = action => {
      switch (action.get('action')) {
        case 'modify':
          return 'primary';
        case 'cancel':
          return 'secondary';
        case 'view':
          return 'primary';
        case 'link':
          return 'primary';

        default:
          return 'primary';
      }
    };
    const actions = [];
    try {
      cellData.forEach(action => {
        if (action.get('type') === 'action') {
          actions.push(
            <Tooltip title={strings[action.get('label')]} placement="left">
              <IconButton
                title={strings[action.get('label')]}
                size="small"
                key={`${action.get('route')}-${rowData.get(uid)}`}
                label={strings[action.get('label')]}
                aria-label={strings[action.get('label')]}
                color={getColor(action)}
                className={getColor(action)}
                onClick={() =>
                  handleOnClick({
                    route: action.get('route'),
                    type: action.get('type'),
                    action: action.get('action'),
                    id: rowData.get(uid),
                  })
                }
                onTouchEnd={() =>
                  handleOnClick({
                    route: action.get('route'),
                    type: action.get('type'),
                    id: rowData.get(uid),
                  })
                }
              >
                {/* {strings[action.get('label')]} */}
                {getIcon(action)}
              </IconButton>
            </Tooltip>
          );
        } else {
          const route = `${action.get('route')}${rowData.get('product')}`;
          const link = props => <Link to={route} {...props} />;
          actions.push(
            <Tooltip key={rowData.get(uid)} title={strings[action.get('label')]} placement="left">
              <IconButton
                // title={strings[action.get('label')]}
                component={React.forwardRef((props, ref) => link(props))}
                size="small"
                key={`${action.get('route')}-${rowData.get(uid)}`}
                label={strings[action.get('label')]}
                aria-label={strings[action.get('label')]}
                color={getColor(action)}
                className={getColor(action)}
              >
                {getIcon(action)}
              </IconButton>
            </Tooltip>
          );
        }
      });
    } catch (e) {
      actions.push(`Invalid link: ${e}`);
    }

    return <>{actions}</>;
  };

  ActionsColumnCellRenderer.propTypes = {
    cellData: PropTypes.any.isRequired,
    rowData: PropTypes.any.isRequired,
  };

  return [
    // {
    //   name: 'code',
    //   label: strings['product.grid.column.code.label'] || 'Code',
    //   width: 40
    // },
    {
      name: 'rec_name',
      label: strings['product.grid.column.name.label'] || 'Name',
      width: 380,
    },
    // {
    //   name: 'start_date',
    //   label: strings['product.grid.column.start_date.label'] || 'Start Date',
    //   width: 80
    // },
    // {
    //   name: 'end_date',
    //   label: strings['product.grid.column.end_date.label'] || 'End Date',
    //   width: 80
    // },
    {
      name: 'actions',
      label: strings['product.grid.column.actions.label'] || 'Actions',
      width: 40,
      type: 'rendered',
      render: ActionsColumnCellRenderer,
    },
  ];
};

// ================
// FILTERS UI
// ================
export const filtersUI = ({ strings }) => ({
  query: {
    value: '',
    label: strings['product.filter.query.label'] || 'Filter by Id or Code or Name',
    placeholder: strings['product.filter.query.placeholder'] || 'eg. Habitation +, 5, habitation_plus',
    type: 'text',
    name: 'query',
  },
});
